import { render, staticRenderFns } from "./RasConfigurazioneLaboratorioViewComponent.vue?vue&type=template&id=9c03442a"
import script from "./RasConfigurazioneLaboratorioViewComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazioneLaboratorioViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports